import React from "react"

const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3333 8.00033H8V11.3337H11.3333V8.00033ZM10.6667 0.666992V2.00033H5.33333V0.666992H4V2.00033H3.33333C2.59333 2.00033 2.00667 2.60033 2.00667 3.33366L2 12.667C2 13.4003 2.59333 14.0003 3.33333 14.0003H12.6667C13.4 14.0003 14 13.4003 14 12.667V3.33366C14 2.60033 13.4 2.00033 12.6667 2.00033H12V0.666992H10.6667ZM12.6667 12.667H3.33333V5.33366H12.6667V12.667Z"
        fill="#1C1F21"
      />
    </svg>
  )
}

export default CalendarIcon
